import React from 'react'
import Contact from '../Components/Contact/Contact'
import Footer from '../Components/footer/Footer'

function ContactComponent() {
    return (

        <>

            <Contact />
            <Footer/>
        </>

    )
}

export default ContactComponent